<template>
	<BaseThemeUiModal name="newsletter-leaving" v-slot="{onClose}" :cookie="true" cookie-expire="1y" :page-leave="pageLeave" :scroll-trigger="isMobile ? 3 : 0" :key-closable="false" :mask-closable="true">
		<div class="nl-popup">
			<div class="nl-popup-header"></div>
			<div class="nw nw-leaving">
				<BaseCmsLabel code="newsletter_widget_title" class="nw-title" tag="div" />
				<BaseCmsLabel code="newsletter_widget_content" class="nw-subtitle" tag="div" />
				<div class="nw-cnt">
					<BaseNewsletterSignupForm class="nw-form nw-popup-form" event="leave" v-slot="{fields, gdprFields, status, loading}">
						<template v-if="!status?.success">
							<BaseFormField v-for="item in fields" :key="item.name" :item="item" v-slot="{errorMessage}">
								<template v-if="item.type != 'hidden'">
									<BaseFormInput class="nw-input" :placeholder="labels.get('enter_email')" />
									<span class="nw-error" v-show="errorMessage" v-html="errorMessage" />
								</template>
								<BaseFormInput v-else />
							</BaseFormField>
							<button class="nw-button" type="submit"><UiLoader v-if="loading" /><BaseCmsLabel v-if="!loading" code="send" tag="span" /></button>
							
							<div class="nw-checkbox" v-if="gdprFields">
								<BaseFormField v-for="field in gdprFields" :key="field.name" :item="field">
									<BaseFormInput v-if="field.type == 'hidden'" />
									<p class="field" v-else v-interpolation>
										<BaseFormInput :id="`nl-leaving-${field.name}`" />
										<label :for="`nl-leaving-${field.name}`">
											<span v-html="field.description"/>
										</label>
									</p>
								</BaseFormField>
							</div>
							<div class="nw-leaving-ty-close" @click="onClose"><BaseCmsLabel code="nw_leaving_ty_close" /></div>
						</template>
						<BaseCmsLabel v-show="status?.success" tag="div" class="nw-success newsletter_subscribe_success" code="success_subscribe" />
					</BaseNewsletterSignupForm>
				</div>
			</div>
		</div>
	</BaseThemeUiModal>
</template>

<script setup>
	const labels = useLabels();
	const {onMediaQuery} = useDom();
	const {matches: isMobile} = onMediaQuery({
		query: '(max-width: 980px)',
	});
	const {gdprApproved} = useGdpr();
	const pageLeave = computed(() => {
		return (!isMobile.value && gdprApproved()?.length) ? true : false;
	});
</script>

<style lang="less" scoped>
	
</style>